import { render, staticRenderFns } from "./forgot.vue?vue&type=template&id=72fc0bc8&scoped=true&lang=pug&"
import script from "./forgot.vue?vue&type=script&lang=js&"
export * from "./forgot.vue?vue&type=script&lang=js&"
import style0 from "../access.scss?vue&type=style&index=0&id=72fc0bc8&lang=scss&scoped=true&"
import style1 from "./forgot.vue?vue&type=style&index=1&id=72fc0bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc0bc8",
  null
  
)

export default component.exports